/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEventType } from './UserEventType';
import {
    UserEventTypeFromJSON,
    UserEventTypeFromJSONTyped,
    UserEventTypeToJSON,
    UserEventTypeToJSONTyped,
} from './UserEventType';

/**
 * 
 * @export
 * @interface UserEventExpirationResponse
 */
export interface UserEventExpirationResponse {
    /**
     * 
     * @type {UserEventType}
     * @memberof UserEventExpirationResponse
     */
    userEvent?: UserEventType;
    /**
     * 
     * @type {any}
     * @memberof UserEventExpirationResponse
     */
    translationResourceKey?: any | null;
    /**
     * 
     * @type {any}
     * @memberof UserEventExpirationResponse
     */
    expiryInDays?: any | null;
}



/**
 * Check if a given object implements the UserEventExpirationResponse interface.
 */
export function instanceOfUserEventExpirationResponse(value: object): value is UserEventExpirationResponse {
    return true;
}

export function UserEventExpirationResponseFromJSON(json: any): UserEventExpirationResponse {
    return UserEventExpirationResponseFromJSONTyped(json, false);
}

export function UserEventExpirationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEventExpirationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userEvent': json['userEvent'] == null ? undefined : UserEventTypeFromJSON(json['userEvent']),
        'translationResourceKey': json['translationResourceKey'] === undefined ? undefined : json['translationResourceKey'] === null ? null : json['translationResourceKey'],
        'expiryInDays': json['expiryInDays'] === undefined ? undefined : json['expiryInDays'] === null ? null : json['expiryInDays'],
    };
}

export function UserEventExpirationResponseToJSON(json: any): UserEventExpirationResponse {
    return UserEventExpirationResponseToJSONTyped(json, false);
}

export function UserEventExpirationResponseToJSONTyped(value?: UserEventExpirationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEvent': UserEventTypeToJSON(value['userEvent']),
        'translationResourceKey': value['translationResourceKey'],
        'expiryInDays': value['expiryInDays'],
    };
}

